import { Injectable, TemplateRef } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  toasts: any = {
    topcenter: [],
    bottomright: []
  }
  history: string[] = []
  
  types: string[] = [
    'asking',
    'success',
    'info',
    'warning',
    'error',
    'loading',
    'note'
  ]

  colors: string[] = [
    '#fff',
    '#198754',
    '#0dcaf0',
    '#ffc107',
    '#dc3545',
    '#0dcaf0',
    '#ffc107'
  ]

  create(type: string, content: string, duration?: number, clear?: boolean, position?: string) {
    const options = {
      type: type,
      delay: duration > 0 ? duration : this.calculateDuration(content),
      isAutoHiding: !duration || duration > -1,
      position: position || 'topcenter'
    }

    if (clear === true) this.clear(options.position)

    this.show(content, options)
    this.log(type, content)
  }

  show(content: string | TemplateRef<any>, options: any = {}) {
    this.toasts[options.position].push({ content, ...options })
    this.history.push(content.toString())
  }

  log(type: string, content: string) {
    const typeIndex = this.types.indexOf(type) || 0
    const color = this.colors[typeIndex]
    console.log(
      `🍞 %c ${type.toUpperCase()} %c ${content}`,
      `background: ${color}; color: black; font-weight: bold`,
      ''
    )
  }
  
  success(content: string, duration?: number, clear?: boolean, position?: string) {
    this.create('success', content, duration, clear, position)
  }
  
  info(content: string, duration?: number, clear?: boolean, position?: string) {
    this.create('info', content, duration, clear, position)
  }
  
  warn(content: string, duration?: number, clear?: boolean, position?: string) {
    this.create('warning', content, duration, clear, position)
  }
  
  error(content: string, duration?: number, clear?: boolean, position?: string) {
    this.create('danger', content, duration, clear, position)
  }
  
  loading(content: string, clear?: boolean, position?: string) {
    this.create('loading', content, -1, clear, position)
  }
  
  note(content: string, clear?: boolean, position?: string) {
    this.create('note', content, -1, clear, position)
  }
  
  askToHidePrevious(content: string, clear?: boolean, position?: string) {
    this.create('asking', content, -1, clear, position)
  }

  calculateDuration(content: string) {
    return 2000 + content.split(' ').length * 500
  }

  remove(toast) {
    this.toasts[toast.position] = this.toasts[toast.position].filter(t => t != toast)
  }

  clear(position?: string) {
    if (position == 'all') {
      this.toasts.topcenter = []
      this.toasts.bottomright = []
      return;
    }

    if (!position) position = 'topcenter'
    
    this.toasts[position] = []
  }
}
